import {
  LEADS_GET_ADMIN_DASHBOARD_DATA,
  LEADS_GET_ADMIN_DASHBOARD_DATA_ERROR,
  CALLS_GET_ADMIN_DASHBOARD_DATA,
  CALLS_GET_ADMIN_DASHBOARD_DATA_SUCCESS,
  CALLS_GET_ADMIN_DASHBOARD_DATA_ERROR,
  LEADS_GET_ADMIN_DASHBOARD_DATA_SUCCESS,
  GET_ADMIN_ANALYTICS_DATA,
  GET_ADMIN_ANALYTICS_DATA_SUCCESS,
  GET_ADMIN_ANALYTICS_DATA_ERROR,
  CLICKS_GET_ADMIN_DASHBOARD_DATA,
  CLICKS_GET_ADMIN_DASHBOARD_DATA_SUCCESS,
  CLICKS_GET_ADMIN_DASHBOARD_DATA_ERROR,
  SYNDI_CLICKS_GET_ADMIN_DASHBOARD_DATA,
  SYNDI_CLICKS_GET_ADMIN_DASHBOARD_DATA_SUCCESS,
  SYNDI_CLICKS_GET_ADMIN_DASHBOARD_DATA_ERROR,
  QUOTE_FUNNELS_GET_ADMIN_DASHBOARD_DATA,
  QUOTE_FUNNELS_GET_ADMIN_DASHBOARD_DATA_SUCCESS,
  QUOTE_FUNNELS_GET_ADMIN_DASHBOARD_DATA_ERROR,
  GET_ADMIN_ANALYTICS_PIXEL_STATS,
  GET_ADMIN_ANALYTICS_PIXEL_STATS_SUCCESS,
  GET_ADMIN_ANALYTICS_PIXEL_STATS_ERROR,
  RESET_ADMIN_ANALYTICS_PIXELS_DATA,
  GET_ADMIN_USER_SMART_VIEWS,
  GET_ADMIN_USER_SMART_VIEWS_SUCCESS,
  CREATE_ADMIN_USER_SMART_VIEW,
  CREATE_ADMIN_USER_SMART_VIEW_SUCCESS,
  CREATE_ADMIN_USER_SMART_VIEW_ERROR,
  UPDATE_ADMIN_USER_SMART_VIEW,
  UPDATE_ADMIN_USER_SMART_VIEW_ERROR,
  RESET_LAST_ADMIN_USER_SMART_VIEW_ACTION,
  UPDATE_ADMIN_USER_SMART_VIEW_SUCCESS,
  GET_ADMIN_ANALYTICS_COMPARE_TO_DATA,
  GET_ADMIN_ANALYTICS_COMPARE_TO_DATA_SUCCESS,
  GET_ADMIN_ANALYTICS_COMPARE_TO_DATA_ERROR,
  GET_ADMIN_ANALYTICS_PIXEL_COMPARE_TO_STATS,
  GET_ADMIN_ANALYTICS_PIXEL_COMPARE_TO_STATS_SUCCESS,
  GET_ADMIN_ANALYTICS_PIXEL_COMPARE_TO_STATS_ERROR,
  GET_ADMIN_USER_SMART_VIEWS_ERROR,
  QUOTE_FUNNELS_LEADS_CALLS_GET_ADMIN_DASHBOARD_DATA,
  QUOTE_FUNNELS_LEADS_CALLS_GET_ADMIN_DASHBOARD_DATA_SUCCESS,
  QUOTE_FUNNELS_LEADS_CALLS_GET_ADMIN_DASHBOARD_DATA_ERROR,
  GET_REVAMPED_ADMIN_ANALYTICS_DATA,
  GET_REVAMPED_ADMIN_ANALYTICS_DATA_SUCCESS,
  GET_REVAMPED_ADMIN_ANALYTICS_COMPARE_TO_DATA,
  GET_REVAMPED_ADMIN_ANALYTICS_COMPARE_TO_DATA_SUCCESS,
  GET_REVAMPED_ADMIN_ANALYTICS_DATA_ERROR,
  GET_REVAMPED_ADMIN_ANALYTICS_COMPARE_TO_DATA_ERROR,
  DASHBOARD_REVAMPED,
  GET_ADMIN_DASHBOARD_REVAMP_DATA,
  GET_ADMIN_DASHBOARD_REVAMP_DATA_SUCCESS,
  GET_ADMIN_DASHBOARD_REVAMP_DATA_ERROR,
  GET_ADMIN_DASHBOARD_DATE_RANGE_REVAMP,
  GET_ADMIN_DASHBOARD_DATE_RANGE_REVAMP_SUCCESS,
  GET_ADMIN_DASHBOARD_DATE_RANGE_REVAMP_ERROR,
  GET_ADMIN_DASHBOARD_COMPARE_TO_REVAMP,
  GET_ADMIN_DASHBOARD_COMPARE_TO_REVAMP_SUCCESS,
  GET_ADMIN_DASHBOARD_COMPARE_TO_REVAMP_ERROR,
  CLEAR_ADMIN_ANALYTICS_COMPARE_DATA
} from './actionTypes';

// export const getDashboardData = (dashboard_query_params, api_type) => ({
//   type: GET_DASHBOARD_DATA,
//   payload: dashboard_query_params,
//   api_type: api_type
// });

// export const getDashboardDataSuccess = (dashboard_data, api_type) => ({
//   type: GET_DASHBOARD_DATA_SUCCESS,
//   payload: dashboard_data,
//   api_type: api_type
// });

// export const getDashboardDataError = (error, api_type) => ({
//   type: GET_DASHBOARD_DATA_ERROR,
//   payload: error,
//   api_type: api_type
// });

//For Clicks
export const getClicksAdminDashboardData = (dashboard_query_params, api_type, api_ver) => ({
  type: CLICKS_GET_ADMIN_DASHBOARD_DATA,
  payload: dashboard_query_params,
  api_type: api_type,
  api_ver: api_ver
});

export const getClicksAdminDashboardDataSuccess = (dashboard_data, api_type) => ({
  type: CLICKS_GET_ADMIN_DASHBOARD_DATA_SUCCESS,
  payload: dashboard_data,
  api_type: api_type
});

export const getClicksAdminDashboardDataError = (error, api_type) => ({
  type: CLICKS_GET_ADMIN_DASHBOARD_DATA_ERROR,
  payload: error,
  api_type: api_type
});

export const getSyndiClicksAdminDashboardData = (dashboard_query_params, api_type, api_ver) => ({
  type: SYNDI_CLICKS_GET_ADMIN_DASHBOARD_DATA,
  payload: dashboard_query_params,
  api_type: api_type,
  api_ver: api_ver
});

export const getSyndiClicksAdminDashboardDataSuccess = (dashboard_data, api_type) => ({
  type: SYNDI_CLICKS_GET_ADMIN_DASHBOARD_DATA_SUCCESS,
  payload: dashboard_data,
  api_type: api_type
});

export const getSyndiClicksAdminDashboardDataError = (error, api_type) => ({
  type: SYNDI_CLICKS_GET_ADMIN_DASHBOARD_DATA_ERROR,
  payload: error,
  api_type: api_type
});

export const getQuoteFunnelsAdminDashboardData = (dashboard_query_params, api_type, api_ver) => ({
  type: QUOTE_FUNNELS_GET_ADMIN_DASHBOARD_DATA,
  payload: dashboard_query_params,
  api_type: api_type,
  api_ver: api_ver
});

export const getQuoteFunnelsAdminDashboardDataSuccess = (dashboard_data, api_type) => ({
  type: QUOTE_FUNNELS_GET_ADMIN_DASHBOARD_DATA_SUCCESS,
  payload: dashboard_data,
  api_type: api_type
});

export const getQuoteFunnelsAdminDashboardDataError = (error, api_type) => ({
  type: QUOTE_FUNNELS_GET_ADMIN_DASHBOARD_DATA_ERROR,
  payload: error,
  api_type: api_type
});

export const getQuoteFunnelsLeadsCallsAdminDashboardData = (dashboard_query_params, api_type, api_ver) => ({
  type: QUOTE_FUNNELS_LEADS_CALLS_GET_ADMIN_DASHBOARD_DATA,
  payload: dashboard_query_params,
  api_type: api_type,
  api_ver: api_ver
});

export const getQuoteFunnelsLeadsCallsAdminDashboardDataSuccess = (dashboard_data, api_type) => ({
  type: QUOTE_FUNNELS_LEADS_CALLS_GET_ADMIN_DASHBOARD_DATA_SUCCESS,
  payload: dashboard_data,
  api_type: api_type
});

export const getQuoteFunnelsLeadsCallsAdminDashboardDataError = (error, api_type) => ({
  type: QUOTE_FUNNELS_LEADS_CALLS_GET_ADMIN_DASHBOARD_DATA_ERROR,
  payload: error,
  api_type: api_type
});

//For Leads
export const getLeadsAdminDashboardData = (dashboard_query_params, api_type) => ({
  type: LEADS_GET_ADMIN_DASHBOARD_DATA,
  payload: dashboard_query_params,
  api_type: api_type
});

export const getLeadsAdminDashboardDataSuccess = (dashboard_data, api_type) => ({
  type: LEADS_GET_ADMIN_DASHBOARD_DATA_SUCCESS,
  payload: dashboard_data,
  api_type: api_type
});

export const getLeadsAdminDashboardDataError = (error, api_type) => ({
  type: LEADS_GET_ADMIN_DASHBOARD_DATA_ERROR,
  payload: error,
  api_type: api_type
});

// For Calls
export const getCallsAdminDashboardData = (dashboard_query_params, api_type, api_ver) => ({
  type: CALLS_GET_ADMIN_DASHBOARD_DATA,
  payload: dashboard_query_params,
  api_type: api_type,
  api_ver: api_ver
});

export const getCallsAdminDashboardDataSuccess = (dashboard_data, api_type) => ({
  type: CALLS_GET_ADMIN_DASHBOARD_DATA_SUCCESS,
  payload: dashboard_data,
  api_type: api_type
});

export const getCallsAdminDashboardDataError = (error, api_type) => ({
  type: CALLS_GET_ADMIN_DASHBOARD_DATA_ERROR,
  payload: error,
  api_type: api_type
});

// export const resetDashboardError = () => ({
//   type: RESET_DASHBOARD_ERROR,
// });


export const getAdminAnalyticsData = (analytics, product_type, api_ver) => {
  return {
    type: GET_ADMIN_ANALYTICS_DATA,
    payload: analytics,
    product_type: product_type,
    api_ver: api_ver
  }
}

export const getAdminAnalyticsDataSuccess = (admin_analytics, total_admin_analytics, product_type) => {
  return {
    type: GET_ADMIN_ANALYTICS_DATA_SUCCESS,
    payload: { admin_analytics, total_admin_analytics },
    product_type: product_type
  }
}

export const getAdminAnalyticsDataError = (error, product_type) => {
  return {
    type: GET_ADMIN_ANALYTICS_DATA_ERROR,
    payload: error,
    product_type: product_type
  }
}


export const getAdminAnalyticsCompareToData = (analytics, product_type, api_ver) => {
  return {
    type: GET_ADMIN_ANALYTICS_COMPARE_TO_DATA,
    payload: analytics,
    product_type: product_type,
    api_ver: api_ver
  }
}

export const getAdminAnalyticsCompareToDataSuccess = (admin_analytics, total_admin_analytics, product_type) => {
  return {
    type: GET_ADMIN_ANALYTICS_COMPARE_TO_DATA_SUCCESS,
    payload: { admin_analytics, total_admin_analytics },
    product_type: product_type
  }
}

export const getAdminAnalyticsCompareToDataError = (error, product_type) => {
  return {
    type: GET_ADMIN_ANALYTICS_COMPARE_TO_DATA_ERROR,
    payload: error,
    product_type: product_type
  }
}
export const dashboardRevamped  = () =>{
  return {
    type: DASHBOARD_REVAMPED
  }
}
export const getRevampedAdminAnalyticsData = (analytics) => {
  return {
    type: GET_REVAMPED_ADMIN_ANALYTICS_DATA,
    payload: analytics,
  }
}

export const getRevampedAdminAnalyticsDataSuccess = (admin_analytics, total_admin_analytics) => {
  return {
    type: GET_REVAMPED_ADMIN_ANALYTICS_DATA_SUCCESS,
    payload: { admin_analytics, total_admin_analytics },
  }
}

export const getRevampedAdminAnalyticsDataError = (error, product_type) => {
  return {
    type: GET_REVAMPED_ADMIN_ANALYTICS_DATA_ERROR,
    payload: error,
    product_type: product_type
  }
}

export const getRevampedAdminAnalyticsCompareToData = (analytics) => {
  return {
    type: GET_REVAMPED_ADMIN_ANALYTICS_COMPARE_TO_DATA,
    payload: analytics,
  }
}

export const getRevampedAdminAnalyticsCompareToDataSuccess = (admin_analytics, total_admin_analytics) => {
  return {
    type: GET_REVAMPED_ADMIN_ANALYTICS_COMPARE_TO_DATA_SUCCESS,
    payload: { admin_analytics, total_admin_analytics },
  }
}

export const getRevampedAdminAnalyticsCompareToDataError = (error, product_type) => {
  return {
    type: GET_REVAMPED_ADMIN_ANALYTICS_COMPARE_TO_DATA_ERROR,
    payload: error,
    product_type: product_type
  }
}

export const getAdminAnalyticsPixelStats = (analytics_pixel_stats, product_type) => {
  return {
    type: GET_ADMIN_ANALYTICS_PIXEL_STATS,
    payload: analytics_pixel_stats,
    product_type: product_type
  }
}

export const getAdminAnalyticsPixelStatsSuccess = (analytics_pixel_stats, product_type) => {
  return {
    type: GET_ADMIN_ANALYTICS_PIXEL_STATS_SUCCESS,
    payload: analytics_pixel_stats,
    product_type: product_type
  }
}

export const getAdminAnalyticsPixelStatsError = (error, product_type) => {
  return {
    type: GET_ADMIN_ANALYTICS_PIXEL_STATS_ERROR,
    payload: error,
    product_type: product_type
  }
}

export const getAdminAnalyticsPixelCompareToStats = (analytics_pixel_stats, product_type) => {
  return {
    type: GET_ADMIN_ANALYTICS_PIXEL_COMPARE_TO_STATS,
    payload: analytics_pixel_stats,
    product_type: product_type
  }
}

export const getAdminAnalyticsPixelCompareToStatsSuccess = (analytics_pixel_stats, product_type) => {
  return {
    type: GET_ADMIN_ANALYTICS_PIXEL_COMPARE_TO_STATS_SUCCESS,
    payload: analytics_pixel_stats,
    product_type: product_type
  }
}

export const getAdminAnalyticsPixelCompareToStatsError = (error, product_type) => {
  return {
    type: GET_ADMIN_ANALYTICS_PIXEL_COMPARE_TO_STATS_ERROR,
    payload: error,
    product_type: product_type
  }
}

export const resetAdminAnalyticsPixelsData = (product_types) => {
  return {
    type: RESET_ADMIN_ANALYTICS_PIXELS_DATA,
    payload: { product_types }
  }
}

export const getAdminUserSmartViews = () => {
  return {
    type: GET_ADMIN_USER_SMART_VIEWS
  }
}

export const getAdminUserSmartViewsSuccess = (payload) => {
  return {
    type: GET_ADMIN_USER_SMART_VIEWS_SUCCESS,
    payload: payload
  }
}

export const getAdminUserSmartViewsError = (error) => {
  return {
    type: GET_ADMIN_USER_SMART_VIEWS_ERROR,
    payload: error
  }
}

export const createAdminUserSmartViews = (payload) => {
  return {
    type: CREATE_ADMIN_USER_SMART_VIEW,
    payload: payload
  }
}

export const createAdminUserSmartViewsSuccess = user_smart_views => {
  return {
    type: CREATE_ADMIN_USER_SMART_VIEW_SUCCESS,
    payload: user_smart_views
  }
}

export const createAdminUserSmartViewsError = error => {
  return {
    type: CREATE_ADMIN_USER_SMART_VIEW_ERROR,
    payload: error
  }
}

export const updateAdminUserSmartViews = (payload) => {
  return {
    type: UPDATE_ADMIN_USER_SMART_VIEW,
    payload: payload
  }
}

export const updateAdminUserSmartViewsSuccess = user_smart_views => {
  return {
    type: UPDATE_ADMIN_USER_SMART_VIEW_SUCCESS,
    payload: user_smart_views
  }
}

export const updateAdminUserSmartViewsError = error => {
  return {
    type: UPDATE_ADMIN_USER_SMART_VIEW_ERROR,
    payload: error
  }
}

export const resetLastAdminUserSmartViewAction = () => {
  return {
    type: RESET_LAST_ADMIN_USER_SMART_VIEW_ACTION
  }
}

export const getAdminDashboardRevampData = (dashboard_query_params) => ({
  type: GET_ADMIN_DASHBOARD_REVAMP_DATA,
  payload: dashboard_query_params
});

export const getAdminDashboardRevampDataSuccess = (dashboard_data) => ({
  type: GET_ADMIN_DASHBOARD_REVAMP_DATA_SUCCESS,
  payload: dashboard_data
});

export const getAdminDashboardRevampDataError = (error) => ({
  type: GET_ADMIN_DASHBOARD_REVAMP_DATA_ERROR,
  payload: error
});

export const getAdminDashboardDateRangeRevamp = (payload) => ({
  type: GET_ADMIN_DASHBOARD_DATE_RANGE_REVAMP,
  payload
});

export const getAdminDashboardDateRangeRevampSuccess = (data) => ({
  type: GET_ADMIN_DASHBOARD_DATE_RANGE_REVAMP_SUCCESS,
  payload: data
});

export const getAdminDashboardDateRangeRevampError = (error) => ({
  type: GET_ADMIN_DASHBOARD_DATE_RANGE_REVAMP_ERROR,
  payload: error
});

export const getAdminDashboardCompareToRevamp = (payload) => ({
  type: GET_ADMIN_DASHBOARD_COMPARE_TO_REVAMP,
  payload
});

export const getAdminDashboardCompareToRevampSuccess = (data) => ({
  type: GET_ADMIN_DASHBOARD_COMPARE_TO_REVAMP_SUCCESS,
  payload: data
});

export const getAdminDashboardCompareToRevampError = (error) => ({
  type: GET_ADMIN_DASHBOARD_COMPARE_TO_REVAMP_ERROR,
  payload: error
});

export const clearAdminAnalyticsCompareData = () => ({
  type: CLEAR_ADMIN_ANALYTICS_COMPARE_DATA
});




